module.exports = __webpack_public_path__ + "static/media/zip.371865d0.svg";